import type { InjectionKey } from "vue";

export type AlertType = "info" | "error" | "success";
export interface Alert {
    type: AlertType;
    message: string;
};

export interface AlertFn {
    (message: string, type: AlertType, timeout?: number): void;
}
export const AlertFnKey = Symbol() as InjectionKey<AlertFn>;

export function useAlert() {
    const alertFn = inject(AlertFnKey);
    return alertFn!;
}
